<template>
  <div
    v-if="queryType === 'confirmed'"
    class="confirmed-text"
  >
    <div class="text-1">
      Transfer Information is Being Confirmed
    </div>
    <div class="text-2">
      Once approved, we will notify you via email immediately.
    </div>
  </div>
  <div
    v-else
    class="payment-info"
  >
    <div class="left-info">
      <div class="title">
        Please Use Bank Transfer to Pay the <br> Order Amount
      </div>
      <div class="subtitle">
        Please read the transfer information carefully and <span>save the transfer screenshot.</span>
      </div>
      <div class="alert-box">
        <img
          src="@/assets/status/warning-blue.svg"
          alt=""
        >
        Don't share your bank transfer transaction number with anyone else.
      </div>
      <div class="price-box">
        <div class="pending-payment">
          Pending Payment
        </div>
        <div class="price">
          <IntlCurrency
            :count="price"
            :size="32"
            currency="us"
          />
        </div>
      </div>
      <div class="order-number">
        <div class="number">
          Order Number: <span>{{ orderNo }}</span>
        </div>
        <div
          @click="handleCopy(orderNo)"
          class="copy-btn"
        >
          Copy
        </div>
      </div>
      <div class="tips-box">
        <img
          src="@/assets/illus/bank-payment-confirm.svg"
          alt=""
        >
        Tips: We will confirm your payment details as soon as possible.
      </div>
    </div>
    <div class="right-info">
      <div class="title">
        Please make the transfer according to the bank information below.
      </div>
      <div class="transport-info">
        <div class="row">
          <div class="image">
            <img
              src="@/assets/H5/order/account-name.svg"
              alt=""
            >
          </div>
          <div class="detail-info-warpper">
            <div class="detail-info">
              <div class="label">
                Account <span>Name</span>:
              </div>
              <div class="value">
                HONG KONG LEYIHUI TECHNOLOGY CO.,LIMITED
              </div>
            </div>
            <div
              @click="handleCopy('HONG KONG LEYIHUI TECHNOLOGY CO.,LIMITED')"
              class="copy-btn"
            >
              Copy
            </div>
          </div>
        </div>
        <div class="row">
          <div class="image">
            <img
              src="@/assets/H5/order/account-number.svg"
              alt=""
            >
          </div>
          <div class="detail-info-warpper">
            <div class="detail-info">
              <div class="label">
                Account <span>Number</span>:
              </div>
              <div class="value">
                NRA009-360801-055
              </div>
            </div>
            <div
              @click="handleCopy('NRA009-360801-055')"
              class="copy-btn"
            >
              Copy
            </div>
          </div>
          <img
            class="tips-image"
            src="@/assets/illus/account-number-tips.svg"
            alt=""
          >
        </div>
        <div class="row">
          <div class="image">
            <img
              src="@/assets/H5/order/bank-name.svg"
              alt=""
            >
          </div>
          <div class="detail-info-warpper">
            <div class="detail-info">
              <div class="label">
                Name of <span>Bank</span>:
              </div>
              <div class="value">
                HSBC BANK (CHINA) COMPANY LIMITED GZH
              </div>
            </div>
            <div
              @click="handleCopy('HSBC BANK (CHINA) COMPANY LIMITED GZH')"
              class="copy-btn"
            >
              Copy
            </div>
          </div>
        </div>
        <div class="row">
          <div class="image">
            <img
              src="@/assets/H5/order/swit-code.svg"
              alt=""
            >
          </div>
          <div class="detail-info-warpper">
            <div class="detail-info">
              <div class="label">
                SWIFT CODE:
              </div>
              <div class="value">
                HSBCCNSHGZH
              </div>
            </div>
            <div
              @click="handleCopy('HSBCCNSHGZH')"
              class="copy-btn"
            >
              Copy
            </div>
          </div>
        </div>
        <div class="row">
          <div class="image">
            <img
              src="@/assets/H5/order/address.svg"
              alt=""
            >
          </div>
          <div class="detail-info-warpper">
            <div class="detail-info">
              <div class="label">
                Beneficiary Address:
              </div>
              <div class="value">
                FLAT/RM 08 15/F WITTY COMMERCIAL BUILDING 1A-1L TUNG CHOI STREETKL, HONG KONG, 999077
              </div>
            </div>
            <div
              @click="handleCopy('FLAT/RM 08 15/F WITTY COMMERCIAL BUILDING 1A-1L TUNG CHOI STREETKL, HONG KONG, 999077')"
              class="copy-btn"
            >
              Copy
            </div>
          </div>
        </div>
        <div class="row">
          <div class="image">
            <img
              src="@/assets/H5/order/address.svg"
              alt=""
            >
          </div>
          <div class="detail-info-warpper no-border">
            <div class="detail-info">
              <div class="label">
                Bank Address:
              </div>
              <div class="value">
                27F AND 28F TAIKOOHUI TOWER 2 NO 381 TIANHE ROAD TIANHE DISTRICT,GUANGZHOU, CHINA, 510000
              </div>
            </div>
            <div
              @click="handleCopy('27F AND 28F TAIKOOHUI TOWER 2 NO 381 TIANHE ROAD TIANHE DISTRICT,GUANGZHOU, CHINA, 510000')"
              class="copy-btn"
            >
              Copy
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { copyText } from '@/utils/utils'
import { usePlugin } from '@/hooks/usePlugin'

const props = defineProps({
  price: {
    type: Number,
    required: true
  }
})

const route = useRoute()

const { $toast } = usePlugin()

const orderNo = computed(() => route.params.orderNo)

const queryType = computed(() => route.query.type)

const handleCopy = (value) => {
  copyText(value).then(() => {
    $toast('Copy Successfully')
  })
}

</script>

<style lang='less' scoped>
.confirmed-text {
  margin-top: 32px;

  .text-1 {
    font-size: 20px;
    font-family: mon-700;
    color: #232323;
    line-height: 28px;
  }

  .text-2 {
    color: #5c5c5c;
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    margin-top: 8px;
    span {
      font-family: mon-600;
    }
  }
}
.payment-info {
  display: flex;
  margin-top: 32px;

  .left-info {
    height: 476px;
    width: 560px;
    padding: 0 48px 0 24px;
    border: 1px solid #ebf1f5;
    border-right: none;
    border-radius: 8px 0 0 8px;
    background-color: #f8f8f8;

    .title {
      color: #232323;
      font-size: 20px;
      font-family: mon-700;
      line-height: 24px;
      margin-top: 32px;
    }

    .subtitle {
      color: #232323;
      font-size: 12px;
      font-family: mon-500;
      line-height: 16px;
      margin-top: 8px;
      span {
        font-family: mon-600;
      }
    }

    .alert-box {
      position: relative;
      display: flex;
      align-items: center;
      height: 48px;
      background-color: #EFF4FD;
      margin-top: 24px;
      color: #1153D6;
      font-size: 12px;
      font-family: mon-500;

      img {
        margin: 0 8px 0 16px;
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background-color: #1153d6;
      }
    }

    .price-box {
      margin-top: 16px;

      .pending-payment {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }

      .price {
        margin-top: 4px;
        color: #052785;
      }
    }

    .order-number {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-top: 4px;
      height: 16px;

      .number {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
      }

      .copy-btn {
        position: absolute;
        right: 0;
        top: -100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        padding: 0 12px;
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        border-radius: 20px;
        background-color: white;
        cursor: pointer;
      }
    }

    .tips-box {
      display: flex;
      align-items: center;
      gap: 12px;
      height: 64px;
      padding: 16px;
      border: 1px solid var(--dark-split-color);
      border-radius: 4px;
      color: #5c5c5c;
      font-size: 12px;
      font-family: mon-500;
      line-height: 16px;
      margin-top: 24px;
    }
  }

  .right-info {
    flex: 1;
    height: 476px;
    border: 1px solid #ebf1f5;
    border-radius: 0 8px 8px 0;
    background-color: white;
    padding: 32px;

    .title {
      color: #232323;
      font-size: 16px;
      font-family: mon-600;
      line-height: 20px;
    }

    .transport-info {
      height: 36px;
      margin-top: 24px;

      .row {
        position: relative;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .image {
          display: flex;
          align-items: center;
          margin-right: 16px;
          height: 36px;
        }

        .detail-info-warpper {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 12px;
          border-bottom: 0.5px solid #e4e6eb;

          &.no-border {
            border: none;
          }

          .detail-info {
            .label {
              color: #232323;
              font-size: 12px;
              font-family: mon-600;
              line-height: 16px;

              span {
                color: #1153d6;
              }
            }

            .value {
              margin-top: 4px;
              color: #5c5c5c;
              font-size: 12px;
              font-family: mon-500;
              line-height: 16px;
            }
          }

          .copy-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 12px;
            height: 32px;
            background-color: #f8f8f8;
            border-radius: 20px;
            color: #232323;
            font-size: 12px;
            font-family: mon-600;
            cursor: pointer;
          }
        }

        .tips-image {
          position: absolute;
          top: -14px;
          left: 170px;
          transition: all .3s ease-in-out;
          animation: shake 2s infinite;

          @keyframes shake {
            0% {
              transform: translateY(0);
            }
            25% {
              transform: translateY(-1px);
            }
            75% {
              transform: translateY(1px);
            }
            100% {
              transform: translateY(0);
            }
          }
        }
      }
    }
  }
}
</style>
